import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import Typography from '@material-ui/core/Typography';
import { MenuItem } from 'components/common/Menu';
import IconButton from 'components/common/IconButton';
import IconWatch from 'components/icons/IconWatch';
import Avatar from 'components/common/Avatar';
import IconCross from 'components/icons/IconCross';

import WatcherAddForm from './WatcherAddForm';

import { updatePatient } from 'redux/modules/patients';

import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  menuItem: {
    textAlign: 'left',
  },
  iconWatch: {
    width: 24,
    height: 24,
    margin: '-2px 0 0 0',
    verticalAlign: 'middle',
  },
  iconContainer: {
    display: 'inline-block',
    position: 'relative',
    marginRight: 8,
  },
  iconContainerWatched: {
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: -2,
      left: 11,
      width: 2,
      height: 24,
      backgroundColor: theme.palette.text.primary,
      transform: 'rotate(-45deg)',
    },
    
  },
  listContainer: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  listContainerFormFocused: {
    minHeight: 200,
  },
  listTitle: {
    padding: '8px 16px',
    whiteSpace: 'nowrap',
  },
  listItem: {
    padding: '8px 28px 8px 16px',
    '& + $listItem': {
      borderTop: `1px solid ${theme.palette.primary.A100}`,
    },
  },
  watcherName: {
    whiteSpace: 'nowrap',
  },
  avatar: {
    width: 28,
    height: 28,
    marginRight: 8,
  },
  buttonRemove: {
    position: 'absolute',
    right: -2,
    top: '50%',
    marginTop: -24,
  },
  iconCross: {
    width: 12,
    height: 12,
  },
  addWatcherForm: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    padding: 8,
  },
});

class Watchers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formFocused: false,
    };

    this.onFormFocus = this.onFormFocus.bind(this);
    this.onFormBlur = this.onFormBlur.bind(this);
  }

  onFormFocus() {
    this.setState({ formFocused: true });
  }

  onFormBlur() {
    this.setState({ formFocused: false });
  }

  render() {
    const { account, patient, actions, classes, onClose } = this.props;
    const { formFocused } = this.state;
    const watchedByUser = patient.Watcher.filter(item => item.ID === account.ID).length > 0;
    return (
      <Fragment>
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            if (watchedByUser) {
              actions.updatePatient({
                values: {
                  'Record Number': patient['Record Number'],
                  'Watcher ID': patient.Watcher.filter(item => item.ID !== account.ID).map(item => item.ID),
                },
              });
            } else {
              actions.updatePatient({
                values: {
                  'Record Number': patient['Record Number'],
                  'Watcher ID': [
                    ...patient.Watcher.map(item => item.ID),
                    account.ID,
                  ],
                },
              });
            }
            onClose();
          }}
        > 
          <div
            className={classNames(classes.iconContainer, {
              [classes.iconContainerWatched]: watchedByUser,
            })}
          >
            <IconWatch className={classes.iconWatch} />
          </div>
          {watchedByUser ? 'Stop Watching' : 'Start Watching'}
        </MenuItem>
        {account.Roles.filter(item =>
          item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length > 0 &&
          <WatcherAddForm
            className={classes.addWatcherForm}
            Watcher={patient.Watcher}
            onFocus={this.onFormFocus}
            onBlur={this.onFormBlur}
            onChange={(values, dispatch, props, prevValues) => {
              actions.updatePatient({
                values: {
                  'Record Number': patient['Record Number'],
                  'Watcher ID': [
                    ...patient.Watcher.map(item => item.ID),
                    values['Watcher ID'],
                  ],
                },
              });
            }}
          />
        }
        {patient.Watcher.length > 0 ? (
          <div
            className={classNames(classes.listContainer, {
              [classes.listContainerFormFocused]: formFocused,
            })}
          >
            <Typography className={classes.listTitle} variant="caption">
              This patient is being watched by
            </Typography>
            <List disablePadding>
              {patient.Watcher.map((item) => {
                let avatarImgSrc = (item.Image && Object.keys(item.Image).length > 0)
                  ? `${item.Image['File Url']}${item.Image['File Name']}`
                  : null;
                if (avatarImgSrc && process.env.REACT_APP_API_ROOT) {
                  avatarImgSrc = `${process.env.REACT_APP_API_ROOT}${avatarImgSrc}`;
                }
                return (
                  <ListItem className={classes.listItem} key={item.ID}>
                    <Avatar className={classes.avatar} src={avatarImgSrc} />
                    <Typography className={classes.watcherName}>
                      {`${item['First Name']} ${item['Last Name']}`}
                    </Typography>
                    {account.Roles.filter(item =>
                      item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length > 0 &&
                      <IconButton
                        className={classes.buttonRemove}
                        onClick={() => {
                          actions.updatePatient({
                            values: {
                              'Record Number': patient['Record Number'],
                              'Watcher ID': patient.Watcher.filter(watcherItem => watcherItem.ID !== item.ID).map(watcherItem => watcherItem.ID),
                            },
                          });
                        }}
                        tooltipContent="Remove Watcher"
                      >
                        <IconCross className={classes.iconCross} />
                      </IconButton>
                    }
                  </ListItem>
                );
              })}      
            </List>
          </div>
        ) : (
          <Fragment>
            {formFocused && (
              <div className={classNames(classes.listContainer, classes.listContainerFormFocused)} />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

Watchers.propTypes = {
  patient: PropTypes.shape({
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
    'Middle Name': PropTypes.string,
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconWatch: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func,
};

Watchers.defaultProps = {
  onClose: () => {},
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updatePatient }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(Watchers),
);



// WEBPACK FOOTER //
// ./src/components/patient/Watchers/Watchers.js